<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">  
    <div class="hidden">
      <img src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Flist.png?alt=media&token=8094f9f9-e3c3-4cce-a004-ceb4b57c60f7"/>
      <img src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fgp.png?alt=media&token=7259247a-c8f4-49c6-9273-7898c3fc4a32"/>
      <img src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fct.png?alt=media&token=eaf0e9aa-c3fd-49df-91d8-f252cf0f2b6b"/>
      <img src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Ffb.png?alt=media&token=5dde0255-6681-4041-95e4-d6cbbfd48ddf"/>
      <img src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Ffs.png?alt=media&token=936ef53c-adfa-4f4d-b7ed-ed65f16b0043"/>
      <img src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fgc.png?alt=media&token=84f53ef2-6e10-4fbf-b5ab-1da8e2f33aaf"/>
      <img src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fta.png?alt=media&token=0c7688cd-c97b-40bf-a398-574485a5a571"/>
      <img src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Ftp.png?alt=media&token=a2ab4a17-1c10-4edf-82a0-163385d31a35"/>
      <img src="https://firebasestorage.googleapis.com/v0/b/feedbacklink-fbl.appspot.com/o/Platform%20logos%2Fye.png?alt=media&token=5e8a6823-8d78-43b5-b49c-907cf6417192"/>
    </div>
    <vx-card class="mb-base pt_ple_shadow " :remove-card-action="true" v-if="$store.getters['dash/isCollaborator'] && timeSinceSignup < (60 * 60 * 24 * 14) ">
    <div class="text-dark text-lg text-left pb-10">
      <p class="m-0 text-center text-sm uppercase">Welcome to the feedback link for {{ $store.state.dash.viewData.business.businessName }}!</p>
      <p class="text-center text-2xl my-10 lg:max-w-md lg:mx-auto">Use feedback link to collect <span class="font-medium text-primary">feedback</span> and generate <span class="font-medium text-primary">word of mouth</span> from your happiest customers!</p>
      <div class="vx-row">
          <div class="vx-col w-full md:w-1/3 text-center pt-4">
            <img src="@/assets/images/misc/surs.png" class="w-16 block mx-auto"/>
            <p class="inline-block mx-auto my-3 text-xl font-medium">✔️Word of Mouth</p>
            <p class="block mx-auto" style="max-width: 20rem;">Generate reviews and social shares by sending invites via email/text, or by simply referring customers to your <vx-tooltip :text="'Your feedback link is: ' + $store.getters['dash/feedbackURL'] + '. It\'s a web address that works on any browser, on any device.'" class="inline-block cursor-pointer italic"><a :href="$store.getters['dash/feedbackURLTest']" target="_blank">feedback link</a>.</vx-tooltip></p>
            <p class="block mx-auto my-4"  style="max-width: 20rem;">All respondents are asked for a rating first. Those who choose a high rating, are immediately guided to review or share online! </p><a href="" @click.prevent="$router.push('/dash/getfeedback/sendinvites')">Send Invites ></a>
          </div>
        <div class="vx-col w-full md:w-1/3 text-center pt-4">
          <div class="bgdiv">
          <img src="@/assets/images/misc/sus.png" class="w-16 block mx-auto"/>
          <p class="inline-block mx-auto my-3 text-xl font-medium">✔️Survey</p>
          <p class="block mx-auto mb-4" style="max-width: 20rem;">Responders who prefer not to review or share, can select "No thanks" and will move on to your custom survey questions. </p><a href="" @click.prevent="$router.push('/dash/surveyflow')">Change survey ></a>
          </div>
        </div>
        <div class="vx-col w-full md:w-1/3 text-center pt-4">
          <div class="bgdiv">
          <img src="@/assets/images/misc/susc.png" class="w-16 block mx-auto"/>
          <p class="inline-block mx-auto my-3 text-xl font-medium">✔️Showcase</p>
          <p class="block mx-auto mb-4" style="max-width: 22rem;">Improve conversion on your website by showcasing your best reviews and feedback with our showcase widget, elegantly surfacing responses. </p>
          <p class="block mx-auto mb-4" style="max-width: 22rem;">You can choose which responses to showcase by selecting "Showcase" next to each new response.</p>
          <p class="block mx-auto text-light text-sm" style="max-width: 22rem;">(You may need to get your account owner to set up the showcase widget on your website first.)</p>
          </div>
        </div>
      </div>
    </div>
    </vx-card>
    <div class="vx-row">
      
      <div class="vx-col w-full sm:w-1/2 xl:w-1/4 mb-base flex" v-if="npsData">        
        <vx-card slot="no-body" title="Net Promoter Score" >
          <span class="block text-light text-center">{{ npsData.responseCount }} response{{ npsData.responseCount > 1 || npsData.responseCount === 0 ? 's': '' }}</span>
          <div class="font-medium text-2xl text-center" :class="{'my-14': npsData.responseCount === 0, 'font-bold text-5xl my-4': npsData.responseCount !== 0,  'text-danger': npsData.score < 0, 'text-warning': npsData.score < 10 && npsData.score >= 0 && npsData.responseCount !== 0, 'text-success': npsData.score > 9}">{{ npsData.responseCount !== 0 ? npsData.score : 'No score' }}</div>
          <div class="text-center mb-4 text-xl" v-if="npsData.score !== false && npsData.responseCount !== 0">
            <span class="text-success" v-if="npsData.score > 50">EXCELLENT</span>
            <span class="text-success" v-if="npsData.score > 29 && npsData.score < 51">VERY GOOD</span>
            <span class="text-success" v-if="npsData.score < 30 && npsData.score > 9">GOOD</span>
            <span class="text-warning" v-if="npsData.score < 10 && npsData.score >= 0">AVERAGE</span>
            <span class="text-danger" v-if="npsData.score < 0">BELOW</span>
          </div>
          <vs-divider/>
          <div class="overflow-auto text-xl text-center mx-auto">
            <div class="float-left w-1/3 cursor-pointer" @click="npsScorePeriod = 'total'" :class="{'font-semibold': npsScorePeriod === 'total'}">
              <span class="text-sm inline-block" style="max-width: 4rem;">All</span>
            </div>
            <div class="float-left w-1/3 cursor-pointer" :class="{'font-semibold': npsScorePeriod === '7'}" @click="npsScorePeriod = '7'">
              <span class="text-sm inline-block" style="max-width: 4rem;">Last 7 Days</span>
            </div>
            <div class="float-left w-1/3 cursor-pointer" :class="{'font-semibold': npsScorePeriod === '30'}" @click="npsScorePeriod = '30'">
              <span class="text-sm inline-block" style="max-width: 4rem;">Last 30 Days</span>
            </div>
          </div>
        </vx-card>      
      </div>

       <div class="vx-col w-full sm:w-1/2 xl:w-1/4 mb-base flex" v-if="starData">        
        <vx-card slot="no-body" title="Star Rating Average" >
          <span class="block text-light text-center">{{ starData.responseCount }} response{{ starData.responseCount > 1 || starData.responseCount === 0 ? 's': '' }}</span>
                    
          <div v-if="starData.responseCount === 0" class="font-medium text-2xl text-center my-14">No score yet</div>                    
          <star-rating v-if="starData.responseCount !== 0" class="justify-center mx-auto font-semibold text-3xl my-7" 
          :class="{'text-danger': starData.score < 2.6, 
          'text-warning': starData.score > 2.5 && starData.score < 3.5 && starData.responseCount !== 0, 
          'text-success': starData.score > 3.4 }" :rating="starData.score" :star-size="30" :read-only="true" :round-start-rating="false"></star-rating>
          <div class="text-center mb-4 text-xl" v-if="starData.score !== false">
            <span class="text-success" v-if="starData.score > 4.4">EXCELLENT</span>
            <span class="text-success" v-if="starData.score > 4 && starData.score < 4.5">VERY GOOD</span>
            <span class="text-success" v-if="starData.score > 3.4 && starData.score < 4.1">GOOD</span>
            <span class="text-warning" v-if="starData.score > 2.9 && starData.score < 3.5">AVERAGE</span>
            <span class="text-danger" v-if="starData.score < 3 && starData.responseCount !== 0">BELOW</span>             
          </div>
          <vs-divider/>
          <div class="overflow-auto text-xl text-center mx-auto">
            <div class="float-left w-1/3 cursor-pointer" @click="starScorePeriod = 'total'" :class="{'font-semibold': starScorePeriod === 'total'}">
              <span class="text-sm inline-block" style="max-width: 4rem;">All</span>
            </div>
            <div class="float-left w-1/3 cursor-pointer" :class="{'font-semibold': starScorePeriod === '7'}" @click="starScorePeriod = '7'">
              <span class="text-sm inline-block" style="max-width: 4rem;">Last 7 Days</span>
            </div>
            <div class="float-left w-1/3 cursor-pointer" :class="{'font-semibold': starScorePeriod === '30'}" @click="starScorePeriod = '30'">
              <span class="text-sm inline-block" style="max-width: 4rem;">Last 30 Days</span>
            </div>
          </div>
        </vx-card>      
      </div>

      <div class="vx-col w-full sm:w-1/2 xl:w-1/4 mb-base flex" v-if="csatData">        
        <vx-card slot="no-body" title="CSAT Rating Average" >
          <span class="block text-light text-center">{{ csatData.responseCount }} response{{ csatData.responseCount > 1 || csatData.responseCount === 0 ? 's': '' }}</span>
          <div class="font-medium text-2xl text-center" 
          :class="{'my-14': csatData.responseCount === 0,'font-bold text-5xl my-4': csatData.responseCount !== 0, 
          'text-danger': csatData.score < 60 && csatData.responseCount !== 0, 
          'text-warning': csatData.score > 59 && csatData.score < 70, 
          'text-success': csatData.score > 69}">{{ csatData.responseCount !== 0 ? `${csatData.score}%` : 'No score yet' }}</div>
          <div class="text-center mb-4 text-xl" v-if="csatData.score !== false">
            <span class="text-success" v-if="csatData.score > 89">EXCELLENT</span>
            <span class="text-success" v-if="csatData.score > 79 && csatData.score < 90">VERY GOOD</span>
            <span class="text-success" v-if="csatData.score > 69 && csatData.score < 80">GOOD</span>
            <span class="text-warning" v-if="csatData.score > 59 && csatData.score < 70">AVERAGE</span>
            <span class="text-danger" v-if="csatData.score < 60 && csatData.responseCount !== 0">BELOW</span>
          </div>
          <vs-divider/>
          <div class="overflow-auto text-xl text-center mx-auto">
            <div class="float-left w-1/3 cursor-pointer" @click="csatScorePeriod = 'total'" :class="{'font-semibold': csatScorePeriod === 'total'}">
              <span class="text-sm inline-block" style="max-width: 4rem;">All</span>
            </div>
            <div class="float-left w-1/3 cursor-pointer" :class="{'font-semibold': csatScorePeriod === '7'}" @click="csatScorePeriod = '7'">
              <span class="text-sm inline-block" style="max-width: 4rem;">Last 7 Days</span>
            </div>
            <div class="float-left w-1/3 cursor-pointer" :class="{'font-semibold': csatScorePeriod === '30'}" @click="csatScorePeriod = '30'">
              <span class="text-sm inline-block" style="max-width: 4rem;">Last 30 Days</span>
            </div>
          </div>
        </vx-card>      
      </div>

      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base flex">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user relative">
          <canvas height="1" width="1" id="confetti" :class="{confettiFull: confettiFull}"></canvas>
          <img src="@/assets/images/elements/decore-left.png" class="pt_decore-left" alt="Decore Left" width="200" >
          <img src="@/assets/images/elements/decore-right.png" class="pt_decore-right" alt="Decore Right" width="175">
          <div>
            <h1 class="mb-6 text-white text-2xl mt-4 font-semibold relative">You're live!</h1>
            <feather-icon icon="LinkIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-5 w-5"></feather-icon>
            <p class="text-white text-lg">Your Feedback Link is</p>
            <vs-button @click="preview" class="px-0 text-white text-lg mx-auto block font-medium" :class="{'lg:text-2xl': $store.getters['dash/feedbackURL'].length > 24, 'lg:text-4xl': $store.getters['dash/feedbackURL'].length <= 24 }" type="flat" :size="$store.getters['dash/feedbackURL'].length > 20 ? 'normal':'large'">{{ $store.getters['dash/feedbackURL'] }} </vs-button>
            <div class="text-center">
              <div class="inline-block"><vs-button type="line" color="#FFFFFF" icon-pack="feather" icon="icon-external-link" class="pt_whitecnt mb-1" @click="preview">Preview</vs-button></div>
              <div class="inline-block"><vs-button class="pt_whitecnt ml-2 mb-1" type="line" color="#FFFFFF"  icon-pack="feather" icon="icon-download" @click="downloadFBLQR">Download QR Code</vs-button></div>
              <div class="inline-block"><vs-button class="pt_whitecnt ml-2 mb-1" type="line" color="#FFFFFF"  icon-pack="feather" icon="icon-copy" @click="copyLink">Copy Link</vs-button></div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 mb-base flex nofilterimags">
        <vx-card slot="no-body" title="Reviews & Shares Triggered">
          <template slot="actions">
            <vx-tooltip position="left" text="This is the number of share/review actions that customers have taken from your feedback link. We cannot trace exactly which review a customer provides, because review platforms do not allow this.">
              <small class="flex cursor-pointer">
                <feather-icon icon="HelpCircleIcon" svgClasses="w-6 h-6 text-dark"></feather-icon>
              </small>
            </vx-tooltip>
          </template>
          <div :class="{'mt-5': $store.getters['dash/sAR'].platformCounts.length < 6}" @click="$router.push('/dash/surveyflow')" class="cursor-pointer">
            <div v-if="$store.getters['dash/sAR'].noActive > 0">
            <div class="overflow-auto my-2">             
            <div class="vx-row" >
              <div class="vx-col w-1/2 lg:w-1/5 text-center offset-2" :class="{'pt-6': i > 4}" v-for="(item,i) in $store.getters['dash/sAR'].platformCounts">
                <p class="text-sm mb-2 text-success" :class="{'text-light': !item.status}">{{ item.status ? 'Active' : 'Inactive' }}</p>
                <div class="overflow-auto relative">
                  <component :is="item.slug" class="w-1/2 block float-left"/>
                  <h2 class="w-1/2 font-normal text-light text-2xl lg:text-3xl pt_count" :class="{'font-bold': item.count > 0, 'text-dark': item.count > 0}">{{ item.count }}</h2>
                </div>
                <p class="mt-2">{{ item.type }}</p>
              </div>
            </div>
            </div>        
          </div>
          <div v-if="$store.getters['dash/sAR'].noActive === 0">
            <p class="mb-2 text-lg text-center">Add your review profiles to collect & showcase reviews!</p>
            <img class="w-full md:w-100 my-0 mx-auto" src="@/assets/images/logo/sandrlogos.png"/>
            <div class="text-center">
              <vs-button class="w-full md:w-80 mt-3 inline-block" type="line" @click="$router.push('/dash/settings/sharingandreviews')">{{ $store.getters['dash/sAR'].noActive === 0 ? 'Set up' : 'Change' }}</vs-button>
            </div>
          </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-6/12 mb-base">
        <h4 v-if="!$store.getters['dash/isCollaborator']" class="font-medium mt-4 mb-4 text-3xl">Get Started!</h4>
        <h4 v-else class="font-medium mt-4 mb-4 text-3xl">Get Reviews & Feedback!</h4>
        <p  v-if="!$store.getters['dash/isCollaborator']" class="text-lg mb-4">You're all set to start getting feedback, reviews and shares from your customers! <span class="font-medium">Here’s how to make it happen:</span></p>
        <p  v-else class="text-lg mb-4">Here's how to start getting feedback, reviews and shares from your customers using Feedback Link:</p>
        <vx-card v-if="!$store.getters['dash/isCollaborator']" slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer" @click="$router.push('/dash/getfeedback/website')">
          <img src="@/assets/images/misc/embed.png" class="w-24 float-left mr-4"/>
          <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
          <h5 class="font-semibold">Install feedback button</h5>
          <p class="mt-2 font-medium">Collect feedback & reviews from your website visitors by installing a feedback button.</p>
        </vx-card>
        <vx-card slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer"  @click="$router.push('/dash/getfeedback/qrcodelink')">
          <img src="@/assets/images/misc/linkqrcode.png" class="w-24 float-left mr-4 mb-3"/>
          <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
          <h5 class="font-semibold">Share Link and QR Code!</h5>
          <p class="mt-2 font-medium">Share your link & QR code with customers at all touchpoints, on and offline.</p>
        </vx-card>
        <vx-card slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer"  @click="$router.push('/dash/getfeedback/sendinvites/email')">
          <img src="@/assets/images/misc/sendinvites.png" class="w-24 float-left mr-4 mb-2"/>
          <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
          <h5 class="font-semibold">Send invites now</h5>
          <p class="mt-2 font-medium">Send email or text invites to customers directly.</p>
        </vx-card>
        <vx-card v-if="!$store.getters['dash/isCollaborator']"  slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer" @click="$router.push('/dash/showcase')">
          <img src="@/assets/images/misc/showcase.png" class="w-24 float-left mr-4"/>
          <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
          <h5 class="font-semibold">Set up Showcase</h5>
          <p class="mt-2 font-medium">Showcase your best reviews & feedback to prospective customers on your website. Drive more sales with social proof.</p>
        </vx-card>
        <vx-card v-if="$store.getters['dash/haveAccessToCollab']" slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer" @click="$router.push('/dash/settings/collaborators')">
          <img src="@/assets/images/misc/collaborators.png" class="w-24 float-left mr-4"/>
          <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
          <h5 class="font-semibold">Invite {{ $store.getters['dash/agency'].isAgency ? 'clients' : 'collaborators' }}</h5>
          <p class="mt-2 font-medium">Invite others to manage, send invites and view feedback for this space.</p>
        </vx-card>
        <vx-card v-if="!$store.getters['dash/isCollaborator']"  slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer" @click="$router.push('/dash/getfeedback/automate')">
          <img src="@/assets/images/misc/automate.png" class="w-24 float-left mr-4"/>
          <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
          <h5 class="font-semibold">Set up Automation</h5>
          <p class="mt-2 font-medium">Automatically collect reviews and feedback from customers by connecting your systems to our developer API.</p>
        </vx-card>
        <vx-card slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer" @click="$router.push('/dash/getfeedback/emailsignature')">
          <img src="@/assets/images/misc/email.png" class="w-24 float-left mr-4"/>
          <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
          <h5 class="font-semibold">Include in day-to-day emails</h5>
          <p class="mt-2 font-medium">Get responses from customers from your email signature or daily emails.</p>
        </vx-card>
        <vx-card slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer" @click="$router.push('/dash/getfeedback/socialmedia')">
          <img src="@/assets/images/misc/askonsocial.png" class="w-24 float-left mr-4 mb-3"/>
          <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
          <h5 class="font-semibold">Ask online now</h5>
          <p class="mt-2 font-medium">The best way to get feedback is to ask! Ask your followers on Facebook, LinkedIn or X.</p>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-6/12 mb-base nofilterimags">
        <!-- Ratings & Reviews (Datashake) homepage widget HIDDEN — Chrome extension replaces Datashake review import. Commented out for quick rollback; uncomment the vx-card below to restore.
        <vx-card slot="no-body" class="mb-5" title="Ratings & Reviews" v-if="$store.getters['dash/hasExternalPlatforms']">
          <div>
            <div class="vx-row" >
              <div class="vx-col w-full lg:w-1/2 mb-base" v-if="$store.getters['dash/externalPlatforms'].gp">
                <h5 class="text-xl"><img src="@/assets/images/logo/gp.png" class="relative icon-down-xs w-4 inline-block"> Google</h5>
                <div v-if="$store.getters['dash/externalPlatforms'].gp.error">
                  <span class="text-sm text-light">We've had some issues getting your Google reviews. Ensure that you've <a href="" @click.prevent="$router.push('/dash/settings/sharingandreviews')">located your business on the map</a>, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
                </div>
                <div v-else>
                  <div class="text-center mt-2" v-if="$store.getters['dash/externalPlatforms'].gp.noReviews === false">
                    <div class="w-8 h-8 pt_loading inline-block"></div>
                    <p class="text-sm max-w-xxs mx-auto"><span class="font-medium">Fetching your reviews!</span> Importing reviews depends on the profile type and review count, and may take anything from 1min. up to an hour.</p>
                  </div>
                  <div v-else >
                    <star-rating v-if="$store.getters['dash/externalPlatforms'].gp.rating !== 0" class="w-full my-1" :rating="$store.getters['dash/externalPlatforms'].gp.rating" :star-size="25" :read-only="true" :round-start-rating="false"></star-rating>
                    <p class="my-2 text-light" v-else>No rating yet</p>
                    <p><span class="cursor-pointer">{{ $store.getters['dash/externalPlatforms'].gp.noReviews }} reviews</span> <span class="text-light text-sm"> | Updated {{ shortDate($store.getters['dash/externalPlatforms'].gp.last_successful_crawl) }}</span></p>
                    <a href="" class="mt-1 inline-block" @click.prevent="$router.push('/dash/responses?platform=gp')">View ></a>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 mb-base" v-if="$store.getters['dash/externalPlatforms'].fb">
                <h5 class="text-xl"><img src="@/assets/images/logo/fb.png" class="relative icon-down-xs w-4 inline-block"> Facebook</h5>
                <div v-if="$store.getters['dash/externalPlatforms'].fb.error">
                  <span class="text-sm text-light">We've had some issues getting your Facebook reviews. Ensure that your <a href="" @click.prevent="$router.push('/dash/settings/sharingandreviews')">profile address</a> is correct, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
                </div>
                <div v-else>
                  <div class="text-center mt-2" v-if="$store.getters['dash/externalPlatforms'].fb.noReviews === false">
                    <div class="w-8 h-8 pt_loading inline-block"></div>
                    <p class="text-sm max-w-xxs mx-auto"><span class="font-medium">Fetching your reviews!</span> Importing reviews depends on the profile type and review count, and may take anything from 1min. up to an hour.</p>
                  </div>
                  <div v-else>
                    <star-rating v-if="$store.getters['dash/externalPlatforms'].fb.rating !== 0" class="w-full my-1" :rating="$store.getters['dash/externalPlatforms'].fb.rating" :star-size="25" :read-only="true" :round-start-rating="false"></star-rating>
                    <p class="my-2 text-light" v-else>No rating yet</p>
                      <p>
                        <span class="">{{ $store.getters['dash/externalPlatforms'].fb.noReviews }} reviews</span>
                        <span class="text-light text-sm"> | Updated {{ shortDate($store.getters['dash/externalPlatforms'].fb.last_successful_crawl) }}</span>
                      </p>
                    <a href="" class="mt-1 inline-block" @click.prevent="$router.push('/dash/responses?platform=fb')">View ></a>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 mb-base" v-if="$store.getters['dash/externalPlatforms'].tp">
                <h5 class="text-xl"><img src="@/assets/images/logo/tp.png" class="relative icon-down-xs w-4 inline-block"> Trustpilot</h5>
                <div v-if="$store.getters['dash/externalPlatforms'].tp.error">
                  <span class="text-sm text-light">We've had some issues getting your Trustpilot reviews. Ensure that your <a href="" @click.prevent="$router.push('/dash/settings/sharingandreviews')">profile address</a> is correct, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
                </div>
                <div v-else>
                  <div class="text-center mt-2" v-if="$store.getters['dash/externalPlatforms'].tp.noReviews === false">
                    <div class="w-8 h-8 pt_loading inline-block"></div>
                    <p class="text-sm max-w-xxs mx-auto"><span class="font-medium">Fetching your reviews!</span> Importing reviews depends on the profile type and review count, and may take anything from 1min. up to an hour.</p>
                  </div>
                  <div v-else>
                    <star-rating v-if="$store.getters['dash/externalPlatforms'].tp.rating !== 0" class="w-full my-1" :rating="$store.getters['dash/externalPlatforms'].tp.rating" :star-size="25" :read-only="true" :round-start-rating="false"></star-rating>
                    <p class="my-2 text-light" v-else>No rating yet</p>
                    <p><span class="">{{ $store.getters['dash/externalPlatforms'].tp.noReviews }} reviews</span><span class="text-light text-sm"> | Updated {{ shortDate($store.getters['dash/externalPlatforms'].tp.last_successful_crawl) }}</span></p>
                    <a href="" class="mt-1 inline-block" @click.prevent="$router.push('/dash/responses?platform=tp')">View ></a>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 mb-base" v-if="$store.getters['dash/externalPlatforms'].ye">
                <h5 class="text-xl"><img src="@/assets/images/logo/ye.png" class="relative icon-down-xs w-4 inline-block"> Yelp</h5>
                <div v-if="$store.getters['dash/externalPlatforms'].ye.error">
                  <span class="text-sm text-light">We've had some issues getting your Yelp reviews. Ensure that your <a href="" @click.prevent="$router.push('/dash/settings/sharingandreviews')">profile address</a> is correct, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
                </div>
                <div v-else>
                  <div class="text-center mt-2" v-if="$store.getters['dash/externalPlatforms'].ye.noReviews === false">
                    <div class="w-8 h-8 pt_loading inline-block"></div>
                    <p class="text-sm max-w-xxs mx-auto"><span class="font-medium">Fetching your reviews!</span> Importing reviews depends on the profile type and review count, and may take anything from 1min. up to an hour.</p>
                  </div>
                  <div v-else @click="$router.push('/dash/responses?platform=ye')">
                    <star-rating v-if="$store.getters['dash/externalPlatforms'].ye.rating !== 0" class="w-full my-1" :rating="$store.getters['dash/externalPlatforms'].ye.rating" :star-size="25" :read-only="true" :round-start-rating="false"></star-rating>
                    <p class="my-2 text-light" v-else>No rating yet</p>
                    <p><span class="">{{ $store.getters['dash/externalPlatforms'].ye.noReviews }} reviews</span><span class="text-light text-sm"> | Updated {{ shortDate($store.getters['dash/externalPlatforms'].ye.last_successful_crawl) }}</span></p>
                    <a href="" class="mt-1 inline-block" @click.prevent="$router.push('/dash/responses?platform=ye')">View ></a>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 mb-base" v-if="$store.getters['dash/externalPlatforms'].fs">
                <h5 class="text-xl"><img src="@/assets/images/logo/fs.png" class="relative icon-down-xs w-4 inline-block"> Foursquare</h5>
                <div v-if="$store.getters['dash/externalPlatforms'].fs.error">
                  <span class="text-sm text-light">We've had some issues getting your Foursquare reviews. Ensure that your <a href="" @click.prevent="$router.push('/dash/settings/sharingandreviews')">profile address</a> is correct, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
                </div>
                <div v-else>
                  <div class="text-center mt-2" v-if="$store.getters['dash/externalPlatforms'].fs.noReviews === false">
                    <div class="w-8 h-8 pt_loading inline-block"></div>
                    <p class="text-sm max-w-xxs mx-auto"><span class="font-medium">Fetching your reviews!</span> Importing reviews depends on the profile type and review count, and may take anything from 1min. up to an hour.</p>
                  </div>
                  <div v-else @click="$router.push('/dash/responses?platform=fs')">
                    <star-rating v-if="$store.getters['dash/externalPlatforms'].fs.rating !== 0" class="w-full my-1" :max-rating="10" :rating="$store.getters['dash/externalPlatforms'].fs.rating" :star-size="15" :read-only="true" :round-start-rating="false"></star-rating>
                    <p class="my-2 text-light" v-else>No rating yet</p>
                    <p><span class="">{{ $store.getters['dash/externalPlatforms'].fs.noReviews }} reviews</span><span class="text-light text-sm"> | Updated {{ shortDate($store.getters['dash/externalPlatforms'].fs.last_successful_crawl) }}</span></p>
                    <a href="" class="mt-1 inline-block" @click.prevent="$router.push('/dash/responses?platform=fs')">View ></a>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 mb-base" v-if="$store.getters['dash/externalPlatforms'].ta">
                <h5 class="text-xl"><img src="@/assets/images/logo/ta.png" class="relative icon-down-xs w-4 inline-block"> TripAdvisor</h5>
                <div v-if="$store.getters['dash/externalPlatforms'].ta.error">
                  <span class="text-sm text-light">We've had some issues getting your TripAdvisor reviews. Ensure that your <a href="" @click.prevent="$router.push('/dash/settings/sharingandreviews')">profile address</a> is correct, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
                </div>
                <div v-else>
                  <div class="text-center mt-2" v-if="$store.getters['dash/externalPlatforms'].ta.noReviews === false">
                    <div class="w-8 h-8 pt_loading inline-block"></div>
                    <p class="text-sm max-w-xxs mx-auto"><span class="font-medium">Fetching your reviews!</span> Importing reviews depends on the profile type and review count, and may take anything from 1min. up to an hour.</p>
                  </div>
                  <div v-else @click="$router.push('/dash/responses?platform=ta')">
                    <star-rating v-if="$store.getters['dash/externalPlatforms'].ta.rating !== 0" class="w-full my-1" :rating="$store.getters['dash/externalPlatforms'].ta.rating" :star-size="25" :read-only="true" :round-start-rating="false"></star-rating>
                    <p class="my-2 text-light" v-else>No rating yet</p>
                    <p><span class="">{{ $store.getters['dash/externalPlatforms'].ta.noReviews }} reviews</span><span class="text-light text-sm"> | Updated {{ shortDate($store.getters['dash/externalPlatforms'].ta.last_successful_crawl) }}</span></p>
                    <a href="" class="mt-1 inline-block" @click.prevent="$router.push('/dash/responses?platform=ta')">View ></a>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 mb-base" v-if="$store.getters['dash/externalPlatforms'].ca">
                <h5 class="text-xl"><img src="@/assets/images/logo/ct.png" class="relative icon-down-xs w-4 inline-block"> Capterra</h5>
                <div v-if="$store.getters['dash/externalPlatforms'].ca.error">
                  <span class="text-sm text-light">We've had some issues getting your Capterra reviews. Ensure that your <a href="" @click.prevent="$router.push('/dash/settings/sharingandreviews')">profile address</a> is correct, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
                </div>
                <div v-else>
                  <div class="text-center mt-2" v-if="$store.getters['dash/externalPlatforms'].ca.noReviews === false">
                    <div class="w-8 h-8 pt_loading inline-block"></div>
                    <p class="text-sm max-w-xxs mx-auto"><span class="font-medium">Fetching your reviews!</span> Importing reviews depends on the profile type and review count, and may take anything from 1min. up to an hour.</p>
                  </div>
                  <div v-else @click="$router.push('/dash/responses?platform=ca')">
                    <star-rating v-if="$store.getters['dash/externalPlatforms'].ca.rating !== 0" class="w-full my-1" :rating="$store.getters['dash/externalPlatforms'].ca.rating" :star-size="25" :read-only="true" :round-start-rating="false"></star-rating>
                    <p class="my-2 text-light" v-else>No rating yet</p>
                    <p><span class="">{{ $store.getters['dash/externalPlatforms'].ca.noReviews }} reviews</span><span class="text-light text-sm"> | Updated {{ shortDate($store.getters['dash/externalPlatforms'].ca.last_successful_crawl) }}</span></p>
                    <a href="" class="mt-1 inline-block" @click.prevent="$router.push('/dash/responses?platform=ca')">View ></a>
                  </div>
                </div>
              </div>
              <div class="vx-col w-full lg:w-1/2 mb-base" v-if="$store.getters['dash/externalPlatforms'].g2">
                <h5 class="text-xl"><img src="@/assets/images/logo/gc.png" class="relative icon-down-xs w-4 inline-block"> G2</h5>
                <div v-if="$store.getters['dash/externalPlatforms'].g2.error">
                  <span class="text-sm text-light">We've had some issues getting your G2 reviews. Ensure that your <a href="" @click.prevent="$router.push('/dash/settings/sharingandreviews')">profile address</a> is correct, or <a href="" @click.prevent="chatToUs">get help</a>.</span>
                </div>
                <div v-else>
                  <div class="text-center mt-2" v-if="$store.getters['dash/externalPlatforms'].g2.noReviews === false">
                    <div class="w-8 h-8 pt_loading inline-block"></div>
                    <p class="text-sm max-w-xxs mx-auto"><span class="font-medium">Fetching your reviews!</span> Importing reviews depends on the profile type and review count, and may take anything from 1min. up to an hour.</p>
                  </div>
                  <div v-else @click="$router.push('/dash/responses?platform=g2')">
                    <star-rating v-if="$store.getters['dash/externalPlatforms'].g2.rating !== 0" class="w-full my-1" :rating="$store.getters['dash/externalPlatforms'].g2.rating" :star-size="25" :read-only="true" :round-start-rating="false"></star-rating>
                    <p class="my-2 text-light" v-else>No rating yet</p>
                    <p><span class="">{{ $store.getters['dash/externalPlatforms'].g2.noReviews }} reviews</span><span class="text-light text-sm"> | Updated {{ shortDate($store.getters['dash/externalPlatforms'].g2.last_successful_crawl) }}</span></p>
                    <a href="" class="mt-1 inline-block" @click.prevent="$router.push('/dash/responses?platform=g2')">View ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
        -->
        <vx-card slot="no-body" title="Survey Flow">
          <div>
            <p class="my-2 text-lg text-center text-dark">Customize your survey flow to suit your goal.</p>
            <img class="w-full lg:w-80 mx-auto block my-4 py-2" style="max-width: 300px;" src="@/assets/images/misc/completesurvey.png"/>
            <div class="text-center">
            <div class="inline-block">
              <vs-button class="w-full lg:w-80" type="line" icon-pack="feather" icon="icon-arrow-right" icon-after  @click="$router.push('/dash/surveyflow')">Change Survey Flow</vs-button>
            </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <vs-popup
      :active.sync="showLTDWelcome"
      title="Welcome"
      class="pt_no_popup_header text-dark p-2"
    >
    <h1 v-if="$route.query.appsumo" class="font-semibold text-center my-8 text-primary">Thank you, Sumoling!</h1>
    <h1 v-else class="font-semibold text-center my-8 text-primary">Thank you for upgrading!</h1>
    <div class="overflow-auto mb-3 relative max-w-sm mx-auto my-2" style="min-height: 10.5rem;" >
      <div class="float-left w-3/12">
        <img src="@/assets/images/misc/ctorcircle.png" class="w-full"/>
        <p class="text-sm text-light text-center">Founder</p>
      </div>
      <div class="float-left w-9/12 absolute" style="left: 25%; top: 50%; transform: translateY(-50%); -webkit-transform: translateY(-50%); -moz-transform: translateY(-50%); ; -o-transform: translateY(-50%);">
        <p class="text-left pl-4">We hope you like Feedback Link! We're very excited to have you. Please get in touch if there's anything. <a class="block mt-2" href="mailto:pieter@feedback.link">pieter@feedback.link</a></p>
      </div>
    </div>
    <vs-divider/>    
    <div v-if="!$route.query.fbl">
    <h3 class="font-medium text-center my-8">Remember to Review Us</h3>
    <p  class="text-xl">We <span class="font-medium">value</span> your feedback & reviews! 
      <span v-if="$route.query.appsumo">Please don't forget to let us know what you think on AppSumo</span>
      <span v-if="$route.query.pitchground">Please don't forget to let us know what you think on Pitchground!</span>
      <span v-if="$route.query.dealify">Please don't forget to let us know what you think on Dealify!</span>    
    </p> 
  </div>   
    <vs-button v-if="$route.query.appsumo" href="https://appsumo.com/marketplace-feedbacklink/#reviews" target="_blank" type="flat" class="w-full my-5">
      <span class="block font-medium text-lg my-2">Review on AppSumo</span>
      <img class="h-5 md:h-10 block mx-auto inline-block" src="@/assets/images/misc/taco.png"/>
    </vs-button>
    <vs-button @click="showLTDWelcome = false" type="border" class="w-full my-5">
      Close
    </vs-button>    
  </vs-popup>
    </div>
  </div>
</template>


<script>




import StarRating from 'vue-star-rating'
import Googlereview from './platformlogos/Googlereview.vue'
import Facebook from './platformlogos/Facebook.vue'
import Tripadvisor from './platformlogos/Tripadvisor.vue'
import Capterra from './platformlogos/Capterra.vue'
import Foursquare from './platformlogos/Foursquare.vue'
import G2 from './platformlogos/G2.vue'
import Trustpilot from './platformlogos/Trustpilot.vue'
import Twitter from './platformlogos/Twitter.vue'
import Yelp from './platformlogos/Yelp.vue'



export default {
  data () {
    return {
      reallyShowAllSAR: false,
      btnsKey: 1,
      showLTDWelcome: false,
      npsScorePeriod: 'total',
      csatScorePeriod: 'total',
      starScorePeriod: 'total',
      showFBRating: false
    }
  },
  components: {
    StarRating,
    gp: Googlereview,
    fb: Facebook,
    ta: Tripadvisor,
    ca: Capterra,
    fs: Foursquare,
    g2: G2,
    tp: Trustpilot,
    tw: Twitter,
    ye: Yelp
  },
  mounted () {
    loadConfetti()

     setTimeout( ()=> {
       //this.showFBRating = true
     }, 4000);

  },
  created () {
    if (typeof this.$route.query.logoutfirst !== 'undefined') {
      this.$vs.notify({
        title: 'Logout first',
        text: 'You need to log out out of your dashboard first.',
        color: 'warning',
        time: 9000,
        iconPack: 'feather',
        icon:'icon-info',
        position: 'top-center'})
    }

    if (
      typeof this.$route.query.appsumo !== 'undefined' ||
      typeof this.$route.query.pitchground !== 'undefined' ||
      typeof this.$route.query.dealify !== 'undefined' || 
      typeof this.$route.query.fbl !== 'undefined' 
      ) {
      this.showLTDWelcome = true
      }

  },
  methods: {
    preview() {      

       //post into iframe to get survey preview
      const form = document.createElement('form')
      form.method = 'post';
  
      // @ts-ignore
      if (process.env.NODE_ENV === 'development') {
        form.action = 'http://localhost:1088/mysurveypreview';
      } else {
        const isAgencyClient = this.$store.getters['dash/isAgencyClientCollaborator']
        form.action = `https://${isAgencyClient ? 'givefdbck.com' : 'feedback.link'}/mysurveypreview`;
      }
      
      form.target = '_blank'       

      //if we need full preview, calculate ratingtype same way as UPDATE_SURVEY_...()
      let ratingType = this.$store.state.dash.viewData.business.surveySetup.ratingType           

      const postData = {
        isAgencyClient: this.$store.getters['dash/isAgencyClientCollaborator'],
        previewType: 'full',
        appearanceInfo: {
            showWhiteLogoBackground: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.showWhiteLogoBackground,
            showWhiteLogoBorder: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.showWhiteLogoBorder,
            secondaryHex: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.secondaryHex,
            backgroundHex: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.backgroundHex,
            logoUrl: this.$store.state.dash.viewData.business.publicFeedbackDetail.appearanceInfo.logoUrl            
        },
        fbaHandle: this.$store.state.dash.viewData.business.publicFeedbackDetail.feedbackAddressHandle,
        platformData: this.$store.state.dash.viewData.business.externalPlatforms,
        businessInfo: this.$store.state.dash.viewData.business.businessInfo,
        language: this.$store.getters['dash/currentLanguagePackName'],
        languagePack: this.$store.getters['dash/currentLanguagePack'],
        stepData: false,
        surveyFlow: [...this.$store.state.dash.viewData.business.surveySetup.surveyFlow],
        ratingType: ratingType
      }
       
      const hiddenField = document.createElement('input')
      hiddenField.type = 'hidden'
      hiddenField.name = 'json'
      hiddenField.value = JSON.stringify(postData)
      form.appendChild(hiddenField)

      document.body.appendChild(form)    

      form.submit() 

      setTimeout(() => {
        form.remove()
      }, 500)

    },
    changeScorePeriod(p){
      this.scorePeriod = p
    },
    downloadFBLQR () {
      let link = document.createElement('a');
      link.href = this.$store.getters['dash/qrfbl64'];
      link.download = 'Feedback Link QR Code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadHappyQR () {
      let link = document.createElement('a');
      link.href = this.$store.getters['dash/qrhappy64'];
      link.download = 'Direct Reviews QR Code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadUnhappyQR () {
      let link = document.createElement('a');
      link.href = this.$store.getters['dash/qrunhappy64'];
      link.download = 'Direct Complaints QR Code.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    copyLink () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.$store.getters['dash/feedbackURL']).then(() => {
          this.$vs.notify({
            title: 'Link Copied',
            text: 'Your feedback link has been copied to your clipboard.',
            color: 'success',
            time: 5000,
            iconPack: 'feather',
            icon:'icon-check-circle',
            position: 'top-center'})
        }, (err) => {
          console.error('Could not copy text: ', err);
          this.$vs.notify({
            title: 'Error',
            text: 'Could not copy the link.',
            color: 'danger',
            time: 5000,
            iconPack: 'feather',
            icon:'icon-alert-circle',
            position: 'top-center'})
        });
      } else {
        const tempInput = document.createElement('input')
        tempInput.value = this.$store.getters['dash/feedbackURL']
        document.body.appendChild(tempInput)
        tempInput.select()
        document.execCommand('copy')
        document.body.removeChild(tempInput)
        this.$vs.notify({
          title: 'Link Copied',
          text: 'Your feedback link has been copied to your clipboard.',
          color: 'success',
          time: 5000,
          iconPack: 'feather',
          icon:'icon-check-circle',
          position: 'top-center'})
      }
    }
  },
  computed: {
     starData() {

      if (!this.$store.getters['dash/score'].star) return false            

      const starData = this.$store.getters['dash/score'].star

      switch (this.starScorePeriod) {
        case 'total':
          return {
            score: starData.allScore,
            responseCount: starData.responseCountAll
          }
          break
        case '30':
          return {
            score: starData.p30score,
            responseCount: starData.responseCount30
          }
          break
        case '7':
          return {
            score: starData.p7score,
            responseCount: starData.responseCount7
          }
          break
      }

      return false

    },
    csatData() {

      if (!this.$store.getters['dash/score'].csat) return false            

      const csatData = this.$store.getters['dash/score'].csat

      switch (this.csatScorePeriod) {
        case 'total':
          return {
            score: csatData.allScore,
            responseCount: csatData.responseCountAll
          }
          break
        case '30':
          return {
            score: csatData.p30score,
            responseCount: csatData.responseCount30
          }
          break
        case '7':
          return {
            score: csatData.p7score,
            responseCount: csatData.responseCount7
          }
          break
      }

      return false

    },
    npsData() {

      if (!this.$store.getters['dash/score'].nps) return false            

      const npsData = this.$store.getters['dash/score'].nps          

      switch (this.npsScorePeriod) {
        case 'total':
          return {
            score: npsData.allScore,
            responseCount: npsData.responseCountAll
          }
          break
        case '30':
          return {
            score: npsData.p30score,
            responseCount: npsData.responseCount30
          }
          break
        case '7':
          return {
            score: npsData.p7score,
            responseCount: npsData.responseCount7
          }
          break
      }

      return false

    },
    timeSinceSignup () {
        return this.$store.getters['dash/timeSinceSignup']
    },
    isOldCollaborator () {
      if (this.$store.getters['dash/isCollaborator']) {

      }
    },
    nowS () {
      return Math.floor(Date. now() / 1000)
    },
    confettiFull () {
      return this.showLTDWelcome
    },
    linkedInURL(){
       return 'http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(this.$store.getters['dash/feedbackURLPublic'])
    },
    fbURL() {
      //return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent('https://feedback.link/bmvvkh')
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.$store.getters['dash/feedbackURLPublic'])
    },
    twitterURL() {
      let urlToShare = encodeURIComponent(this.$store.getters['dash/feedbackURLFullPublic'])
      let text = encodeURIComponent('We\'d love to hear your feedback on your experience with us, please help us improve! Visit ')
      let hashtags = 'feedback,service,recommendation,thankyou'
      return 'https://x.com/intent/post?text=' + text + '&hashtags=' + hashtags + (urlToShare ? '&url=' + urlToShare : '')
    },
    showAllSAR: {
      get () {
        if (this.$store.getters['dash/sAR'].noActive < 4) {
          return true
        } else {
          return false
        }
      },
      set (v) {
        this.reallyShowAllSAR = true
      }
    }
  }
}


function loadConfetti(){


      var retina = window.devicePixelRatio,

        // Math shorthands
        PI = Math.PI,
        sqrt = Math.sqrt,
        round = Math.round,
        random = Math.random,
        cos = Math.cos,
        sin = Math.sin,

        // Local WindowAnimationTiming interface
        rAF = window.requestAnimationFrame,
        cAF = window.cancelAnimationFrame || window.cancelRequestAnimationFrame,
        _now = Date.now || function() {
          return new Date().getTime();
        };

      // Local WindowAnimationTiming interface polyfill
      (function(w) {
        /**
         * Fallback implementation.
         */
        var prev = _now();

        function fallback(fn) {
          var curr = _now();
          var ms = Math.max(0, 16 - (curr - prev));
          var req = setTimeout(fn, ms);
          prev = curr;
          return req;
        }

        /**
         * Cancel.
         */
        var cancel = w.cancelAnimationFrame ||
          w.webkitCancelAnimationFrame ||
          w.clearTimeout;

        rAF = w.requestAnimationFrame ||
          w.webkitRequestAnimationFrame ||
          fallback;

        cAF = function(id) {
          cancel.call(w, id);
        };
      }(window));


        var speed = 65,
          duration = (1.0 / speed),
          confettiRibbonCount = 11,
          ribbonPaperCount = 30,
          ribbonPaperDist = 5.0,
          ribbonPaperThick = 5.0,
          confettiPaperCount = 155,
          DEG_TO_RAD = PI / 180,
          RAD_TO_DEG = 180 / PI,
          colors = [
            ["#df0049", "#660671"],
            ["#00e857", "#005291"],
            ["#2bebbc", "#05798a"],
            ["#ffd200", "#b06c00"]
          ];

        function Vector2(_x, _y) {
          this.x = _x, this.y = _y;
          this.Length = function() {
            return sqrt(this.SqrLength());
          }
          this.SqrLength = function() {
            return this.x * this.x + this.y * this.y;
          }
          this.Add = function(_vec) {
            this.x += _vec.x;
            this.y += _vec.y;
          }
          this.Sub = function(_vec) {
            this.x -= _vec.x;
            this.y -= _vec.y;
          }
          this.Div = function(_f) {
            this.x /= _f;
            this.y /= _f;
          }
          this.Mul = function(_f) {
            this.x *= _f;
            this.y *= _f;
          }
          this.Normalize = function() {
            var sqrLen = this.SqrLength();
            if (sqrLen != 0) {
              var factor = 1.0 / sqrt(sqrLen);
              this.x *= factor;
              this.y *= factor;
            }
          }
          this.Normalized = function() {
            var sqrLen = this.SqrLength();
            if (sqrLen != 0) {
              var factor = 1.0 / sqrt(sqrLen);
              return new Vector2(this.x * factor, this.y * factor);
            }
            return new Vector2(0, 0);
          }
        }
        Vector2.Lerp = function(_vec0, _vec1, _t) {
          return new Vector2((_vec1.x - _vec0.x) * _t + _vec0.x, (_vec1.y - _vec0.y) * _t + _vec0.y);
        }
        Vector2.Distance = function(_vec0, _vec1) {
          return sqrt(Vector2.SqrDistance(_vec0, _vec1));
        }
        Vector2.SqrDistance = function(_vec0, _vec1) {
          var x = _vec0.x - _vec1.x;
          var y = _vec0.y - _vec1.y;
          return (x * x + y * y + z * z);
        }
        Vector2.Scale = function(_vec0, _vec1) {
          return new Vector2(_vec0.x * _vec1.x, _vec0.y * _vec1.y);
        }
        Vector2.Min = function(_vec0, _vec1) {
          return new Vector2(Math.min(_vec0.x, _vec1.x), Math.min(_vec0.y, _vec1.y));
        }
        Vector2.Max = function(_vec0, _vec1) {
          return new Vector2(Math.max(_vec0.x, _vec1.x), Math.max(_vec0.y, _vec1.y));
        }
        Vector2.ClampMagnitude = function(_vec0, _len) {
          var vecNorm = _vec0.Normalized;
          return new Vector2(vecNorm.x * _len, vecNorm.y * _len);
        }
        Vector2.Sub = function(_vec0, _vec1) {
          return new Vector2(_vec0.x - _vec1.x, _vec0.y - _vec1.y, _vec0.z - _vec1.z);
        }

        function EulerMass(_x, _y, _mass, _drag) {
          this.position = new Vector2(_x, _y);
          this.mass = _mass;
          this.drag = _drag;
          this.force = new Vector2(0, 0);
          this.velocity = new Vector2(0, 0);
          this.AddForce = function(_f) {
            this.force.Add(_f);
          }
          this.Integrate = function(_dt) {
            var acc = this.CurrentForce(this.position);
            acc.Div(this.mass);
            var posDelta = new Vector2(this.velocity.x, this.velocity.y);
            posDelta.Mul(_dt);
            this.position.Add(posDelta);
            acc.Mul(_dt);
            this.velocity.Add(acc);
            this.force = new Vector2(0, 0);
          }
          this.CurrentForce = function(_pos, _vel) {
            var totalForce = new Vector2(this.force.x, this.force.y);
            var speed = this.velocity.Length();
            var dragVel = new Vector2(this.velocity.x, this.velocity.y);
            dragVel.Mul(this.drag * this.mass * speed);
            totalForce.Sub(dragVel);
            return totalForce;
          }
        }

        function ConfettiPaper(_x, _y) {
          this.pos = new Vector2(_x, _y);
          this.rotationSpeed = (random() * 600 + 800);
          this.angle = DEG_TO_RAD * random() * 360;
          this.rotation = DEG_TO_RAD * random() * 360;
          this.cosA = 1.0;
          this.size = 5.0;
          this.oscillationSpeed = (random() * 1.5 + 0.5);
          this.xSpeed = 40.0;
          this.ySpeed = (random() * 60 + 50.0);
          this.corners = new Array();
          this.time = random();
          var ci = round(random() * (colors.length - 1));
          this.frontColor = colors[ci][0];
          this.backColor = colors[ci][1];
          for (var i = 0; i < 4; i++) {
            var dx = cos(this.angle + DEG_TO_RAD * (i * 90 + 45));
            var dy = sin(this.angle + DEG_TO_RAD * (i * 90 + 45));
            this.corners[i] = new Vector2(dx, dy);
          }
          this.Update = function(_dt) {
            this.time += _dt;
            this.rotation += this.rotationSpeed * _dt;
            this.cosA = cos(DEG_TO_RAD * this.rotation);
            this.pos.x += cos(this.time * this.oscillationSpeed) * this.xSpeed * _dt
            this.pos.y += this.ySpeed * _dt;
            if (this.pos.y > ConfettiPaper.bounds.y) {
              this.pos.x = random() * ConfettiPaper.bounds.x;
              this.pos.y = 0;
            }
          }
          this.Draw = function(_g) {
            if (this.cosA > 0) {
              _g.fillStyle = this.frontColor;
            } else {
              _g.fillStyle = this.backColor;
            }
            _g.beginPath();
            _g.moveTo((this.pos.x + this.corners[0].x * this.size) * retina, (this.pos.y + this.corners[0].y * this.size * this.cosA) * retina);
            for (var i = 1; i < 4; i++) {
              _g.lineTo((this.pos.x + this.corners[i].x * this.size) * retina, (this.pos.y + this.corners[i].y * this.size * this.cosA) * retina);
            }
            _g.closePath();
            _g.fill();
          }
        }
        ConfettiPaper.bounds = new Vector2(0, 0);

        function ConfettiRibbon(_x, _y, _count, _dist, _thickness, _angle, _mass, _drag) {
          this.particleDist = _dist;
          this.particleCount = _count;
          this.particleMass = _mass;
          this.particleDrag = _drag;
          this.particles = new Array();
          var ci = round(random() * (colors.length - 1));
          this.frontColor = colors[ci][0];
          this.backColor = colors[ci][1];
          this.xOff = (cos(DEG_TO_RAD * _angle) * _thickness);
          this.yOff = (sin(DEG_TO_RAD * _angle) * _thickness);
          this.position = new Vector2(_x, _y);
          this.prevPosition = new Vector2(_x, _y);
          this.velocityInherit = (random() * 2 + 4);
          this.time = random() * 100;
          this.oscillationSpeed = (random() * 2 + 2);
          this.oscillationDistance = (random() * 40 + 40);
          this.ySpeed = (random() * 100 + 80);
          for (var i = 0; i < this.particleCount; i++) {
            this.particles[i] = new EulerMass(_x, _y - i * this.particleDist, this.particleMass, this.particleDrag);
          }
          this.Update = function(_dt) {
            var i = 0;
            this.time += _dt * this.oscillationSpeed;
            this.position.y += this.ySpeed * _dt;
            this.position.x += cos(this.time) * this.oscillationDistance * _dt;
            this.particles[0].position = this.position;
            var dX = this.prevPosition.x - this.position.x;
            var dY = this.prevPosition.y - this.position.y;
            var delta = sqrt(dX * dX + dY * dY);
            this.prevPosition = new Vector2(this.position.x, this.position.y);
            for (i = 1; i < this.particleCount; i++) {
              var dirP = Vector2.Sub(this.particles[i - 1].position, this.particles[i].position);
              dirP.Normalize();
              dirP.Mul((delta / _dt) * this.velocityInherit);
              this.particles[i].AddForce(dirP);
            }
            for (i = 1; i < this.particleCount; i++) {
              this.particles[i].Integrate(_dt);
            }
            for (i = 1; i < this.particleCount; i++) {
              var rp2 = new Vector2(this.particles[i].position.x, this.particles[i].position.y);
              rp2.Sub(this.particles[i - 1].position);
              rp2.Normalize();
              rp2.Mul(this.particleDist);
              rp2.Add(this.particles[i - 1].position);
              this.particles[i].position = rp2;
            }
            if (this.position.y > ConfettiRibbon.bounds.y + this.particleDist * this.particleCount) {
              this.Reset();
            }
          }
          this.Reset = function() {
            this.position.y = -random() * ConfettiRibbon.bounds.y;
            this.position.x = random() * ConfettiRibbon.bounds.x;
            this.prevPosition = new Vector2(this.position.x, this.position.y);
            this.velocityInherit = random() * 2 + 4;
            this.time = random() * 100;
            this.oscillationSpeed = random() * 2.0 + 1.5;
            this.oscillationDistance = (random() * 40 + 40);
            this.ySpeed = random() * 40 + 80;
            var ci = round(random() * (colors.length - 1));
            this.frontColor = colors[ci][0];
            this.backColor = colors[ci][1];
            this.particles = new Array();
            for (var i = 0; i < this.particleCount; i++) {
              this.particles[i] = new EulerMass(this.position.x, this.position.y - i * this.particleDist, this.particleMass, this.particleDrag);
            }
          }
          this.Draw = function(_g) {
            for (var i = 0; i < this.particleCount - 1; i++) {
              var p0 = new Vector2(this.particles[i].position.x + this.xOff, this.particles[i].position.y + this.yOff);
              var p1 = new Vector2(this.particles[i + 1].position.x + this.xOff, this.particles[i + 1].position.y + this.yOff);
              if (this.Side(this.particles[i].position.x, this.particles[i].position.y, this.particles[i + 1].position.x, this.particles[i + 1].position.y, p1.x, p1.y) < 0) {
                _g.fillStyle = this.frontColor;
                _g.strokeStyle = this.frontColor;
              } else {
                _g.fillStyle = this.backColor;
                _g.strokeStyle = this.backColor;
              }
              if (i == 0) {
                _g.beginPath();
                _g.moveTo(this.particles[i].position.x * retina, this.particles[i].position.y * retina);
                _g.lineTo(this.particles[i + 1].position.x * retina, this.particles[i + 1].position.y * retina);
                _g.lineTo(((this.particles[i + 1].position.x + p1.x) * 0.5) * retina, ((this.particles[i + 1].position.y + p1.y) * 0.5) * retina);
                _g.closePath();
                _g.stroke();
                _g.fill();
                _g.beginPath();
                _g.moveTo(p1.x * retina, p1.y * retina);
                _g.lineTo(p0.x * retina, p0.y * retina);
                _g.lineTo(((this.particles[i + 1].position.x + p1.x) * 0.5) * retina, ((this.particles[i + 1].position.y + p1.y) * 0.5) * retina);
                _g.closePath();
                _g.stroke();
                _g.fill();
              } else if (i == this.particleCount - 2) {
                _g.beginPath();
                _g.moveTo(this.particles[i].position.x * retina, this.particles[i].position.y * retina);
                _g.lineTo(this.particles[i + 1].position.x * retina, this.particles[i + 1].position.y * retina);
                _g.lineTo(((this.particles[i].position.x + p0.x) * 0.5) * retina, ((this.particles[i].position.y + p0.y) * 0.5) * retina);
                _g.closePath();
                _g.stroke();
                _g.fill();
                _g.beginPath();
                _g.moveTo(p1.x * retina, p1.y * retina);
                _g.lineTo(p0.x * retina, p0.y * retina);
                _g.lineTo(((this.particles[i].position.x + p0.x) * 0.5) * retina, ((this.particles[i].position.y + p0.y) * 0.5) * retina);
                _g.closePath();
                _g.stroke();
                _g.fill();
              } else {
                _g.beginPath();
                _g.moveTo(this.particles[i].position.x * retina, this.particles[i].position.y * retina);
                _g.lineTo(this.particles[i + 1].position.x * retina, this.particles[i + 1].position.y * retina);
                _g.lineTo(p1.x * retina, p1.y * retina);
                _g.lineTo(p0.x * retina, p0.y * retina);
                _g.closePath();
                _g.stroke();
                _g.fill();
              }
            }
          }
          this.Side = function(x1, y1, x2, y2, x3, y3) {
            return ((x1 - x2) * (y3 - y2) - (y1 - y2) * (x3 - x2));
          }
        }
        ConfettiRibbon.bounds = new Vector2(0, 0);
        confetti = {};
        confetti.Context = function(id) {
          var i = 0;
          var canvas = document.getElementById(id);
          var canvasParent = canvas.parentNode;
          var canvasWidth = canvasParent.offsetWidth;
          var canvasHeight = canvasParent.offsetHeight;
          canvas.width = canvasWidth * retina;
          canvas.height = canvasHeight * retina;
          var context = canvas.getContext('2d');
          var interval = null;
          var confettiRibbons = new Array();
          ConfettiRibbon.bounds = new Vector2(canvasWidth, canvasHeight);
          for (i = 0; i < confettiRibbonCount; i++) {
            confettiRibbons[i] = new ConfettiRibbon(random() * canvasWidth, -random() * canvasHeight * 2, ribbonPaperCount, ribbonPaperDist, ribbonPaperThick, 45, 1, 0.05);
          }
          var confettiPapers = new Array();
          ConfettiPaper.bounds = new Vector2(canvasWidth, canvasHeight);
          for (i = 0; i < confettiPaperCount; i++) {
            confettiPapers[i] = new ConfettiPaper(random() * canvasWidth, random() * canvasHeight);
          }
          this.resize = function() {
            canvasWidth = canvasParent.offsetWidth;
            canvasHeight = canvasParent.offsetHeight;
            canvas.width = canvasWidth * retina;
            canvas.height = canvasHeight * retina;
            ConfettiPaper.bounds = new Vector2(canvasWidth, canvasHeight);
            ConfettiRibbon.bounds = new Vector2(canvasWidth, canvasHeight);
          }
          this.start = function() {
            this.stop()
            var context = this;
            this.update();
          }
          this.stop = function() {
            cAF(this.interval);
          }
          this.update = function() {
            var i = 0;
            context.clearRect(0, 0, canvas.width, canvas.height);
            for (i = 0; i < confettiPaperCount; i++) {
              confettiPapers[i].Update(duration);
              confettiPapers[i].Draw(context);
            }
            for (i = 0; i < confettiRibbonCount; i++) {
              confettiRibbons[i].Update(duration);
              confettiRibbons[i].Draw(context);
            }
            this.interval = rAF(function() {
              confetti.update();
            });
          }
        }
        var confetti = new confetti.Context('confetti');
        confetti.start();
        window.addEventListener('resize', function(event){
          confetti.resize();
        });
}

/*

<div class="inline-block">
  <vs-button icon-pack="feather" icon="icon-arrow-down" icon-after class="w-64 mt-3" type="line" @click="$router.push('/dash/settings/sharingandreviews')">See all</vs-button>
</div>
<div class="inline-block ml-2">
  <vs-button icon-pack="feather" icon="icon-arrow-right" icon-after class="w-64 mt-3" type="line" @click="$router.push('/dash/settings/sharingandreviews')">Modify</vs-button>
</div>

<div class="vx-row">
  <div class="vx-col w-full lg:px-32 xl:px-64 mb-base">
    <h4 class="w-full my-6 text-3xl font-medium text-center">How to get started</h4>
    <p class="text-center text-lg my-6">You're now ready to start getting feedback! Follow the below steps to make it happen.</p>
    <vx-card title="Share Link and QR Code with Customers" class="pt_strong_title my-base bg-transparent">
      <p class="text-xl my-2">Your feedback link is <a class="" :href="$store.getters['dash/feedbackURLTest']" target="_blank">{{ $store.getters['dash/feedbackURL'] }}</a></p>
      <p class="text-lg my-2 font-medium">The best way to get feedback is to ask. Make sure customers are shown this whenever they interact with your business!</p>
      <p class="my-2 text-lg">You can use your QR code to make visiting your feedback link easier. <a href="https://www.dummies.com/business/marketing/social-media-marketing/how-to-scan-a-qr-code/" target="_blank">What is a QR Code?</a></p>
      <div class="inline-block"><vs-button type="line" class="my-2 w-64"  icon-pack="feather" icon="icon-external-link" target="_blank" href="https://feedback.link/#howtogetfeedback" icon-after>See some ideas</vs-button></div>
      <div class="inline-block sm:ml-2"><vs-button type="line" class="my-2 w-64" icon-pack="feather" icon="icon-download" icon-after @click="downloadFBLQR">Download QR code</vs-button></div>
      <img class="block arrownextquestiondownmb" src="@/assets/images/misc/arrownextquestion.png"/>
    </vx-card>
    <vx-card title="Web Widget" class="mt-4 pt_strong_title my-8 bg-transparent">
      <p class="text-xl">Have a website or web app? Gather feedback from your users by adding a feedback button to your site or customer dashboard.</p>
      <p class="my-2 text-lg font-medium">This will allow users to give seamless feedback without leaving your web property.</p>
      <vs-button type="line" class="my-2" icon-pack="feather" icon="icon-arrow-right" icon-after @click="$router.push('/dash/getfeedback/website')">Set up web widget</vs-button>
      <img class="block arrownextquestiondownmb" src="@/assets/images/misc/arrownextquestion.png"/>
    </vx-card>
    <vx-card title="Email Signature" class="pt_strong_title my-base">

      <p class="text-xl my-2">Add rating buttons into your email signature to gather feedback from email interactions.</p>
      <p class="my-2">Anyone that clicks a rating, will be taken directly to your feedback link.</p>
      <vs-button type="line" class="my-2" icon-pack="feather" icon="icon-arrow-right" icon-after @click.prevent="$router.push('/dash/getfeedback/emailsignature')">Email signature</vs-button>
      <img class="block arrownextquestiondownmb" src="@/assets/images/misc/arrownextquestion.png"/>
    </vx-card>
    <vx-card title="Send Invites" class="pt_strong_title my-base">

      <p class="text-xl my-2"><span class="font-medium">Have a list of your customers' numbers or emails?</span> Send emails or texts inviting customers to give feedback.</p>
      <div class="inline-block"><vs-button type="line" class="my-2 w-64"  icon-pack="feather" icon="icon-arrow-right" icon-after @click="$router.push('/dash/getfeedback/sendinvites/email')">Send Email Invites</vs-button></div>
      <div class="inline-block sm:ml-2"><vs-button type="line" class="my-2 w-64" icon-pack="feather" icon="icon-arrow-right" icon-after @click="$router.push('/dash/getfeedback/sendinvites/text')">Send Text Invites</vs-button></div>
      <img class="block arrownextquestiondownmb" src="@/assets/images/misc/arrownextquestion.png"/>
    </vx-card>
    <vx-card title="Ask Online" class="pt_strong_title my-base">

      <p class="text-xl my-2">Be sure to ask your followers for feedback online!</p>
      <p>Select a platform where you'd like to ask. A new window will pop-up where a post will be generated.</p>
      <div class="my-4 w-full md:w-80">
        <vs-button size="large" :href="fbURL" target="_blank"  class="w-full my-3" color="#3B5998" icon-pack="feather" icon="icon-external-link" icon-after >Share on Facebook</vs-button>
        <vs-button size="large" :href="linkedInURL" target="_blank"  class="w-full my-3" color="#0072B1" icon-pack="feather" icon="icon-external-link" icon-after >Share on LinkedIn</vs-button>
        <vs-button size="large" :href="twitterURL" target="_blank" class="w-full my-3" color="#000000" icon-pack="feather" icon="icon-external-link" icon-after >Post on X</vs-button>
      </div>
    </vx-card>
  </div>

</div>

<div>
  <gp/>
  Google Review
  {{ $store.getters['dash/sAR'].googleCount }}
</div>
 <vs-chip class="px-4 pl-2 m-1" v-if="$store.getters['dash/sAR'].facebookReview">
   <img src="@/assets/images/logo/fb.png" class="w-5 mr-2"/>
   Review
   {{ $store.getters['dash/sAR'].facebookReviewCount }}
 </vs-chip>
 <vs-chip class="px-4 pl-2 m-1" v-if="$store.getters['dash/sAR'].trustPilot"  >
     <tp/>
     Trustpilot
     {{ $store.getters['dash/sAR'].trustPilotCount }}
 </vs-chip>
 <vs-chip class="px-4 pl-2 m-1" v-if="$store.getters['dash/sAR'].twitter"  >
     <tw/>
     X posts
     {{ $store.getters['dash/sAR'].twitterCount }}
 </vs-chip>

  <div v-if="reallyShowAllSAR || showAllSAR">

    <vs-chip class="px-4 pl-2 m-1" v-if="$store.getters['dash/sAR'].facebookShare">
     <fb/>
      Share
      {{ $store.getters['dash/sAR'].facebookShareCount }}
    </vs-chip>

  <vs-chip class="px-4 pl-2 m-1" v-if="$store.getters['dash/sAR'].tripAdvisor" >
     <ta/>
     Tripadvisor
     {{ $store.getters['dash/sAR'].tripAdvisorCount }}
  </vs-chip>

  <vs-chip class="px-4 pl-2 m-1" v-if="$store.getters['dash/sAR'].capterra" >
     <ca/>
     Capterra
     {{ $store.getters['dash/sAR'].capterraCount }}
  </vs-chip>

  <vs-chip class="px-4 pl-2 m-1" v-if="$store.getters['dash/sAR'].fourSquare"  >
      <fs/>
      Foursquare
      {{ $store.getters['dash/sAR'].foursquareCount }}
  </vs-chip>

  <vs-chip class="px-4 pl-2 m-1" v-if="$store.getters['dash/sAR'].g2" >
      <g2/>
      G2
      {{ $store.getters['dash/sAR'].g2Count }}
  </vs-chip>

  <vs-chip class="px-4 pl-2 m-1" v-if="$store.getters['dash/sAR'].yelp" >
      <ye/>
      Yelp
      {{ $store.getters['dash/sAR'].yelpCount }}
  </vs-chip>
</div>

<div class="vx-row">
  <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
    <h4 class="font-medium mt-4 mb-4 text-2xl">Start getting feedback & reviews</h4>
    <p class="text-lg mb-4">You're all set for your customers to give feedback, reviews and shares! <span class="font-medium">Here’s how to make it happen:</span></p>
    <vx-card slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer">
      <img src="@/assets/images/misc/embed.png" class="w-24 float-left mr-4"/>
      <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
      <h5 class="font-semibold">Add to your website</h5>
      <p class="mt-2">Allow your website visitors to give feedback & reviews by installing a feedback button.</p>
    </vx-card>
    <vx-card slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer">
      <img src="@/assets/images/misc/linkqrcode.png" class="w-24 float-left mr-4"/>
      <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
      <h5 class="font-semibold">Share Link and QR Code!</h5>
      <p class="mt-2">Share your link & QR code with customers at all touchpoints, on and offline.</p>
    </vx-card>
    <vx-card slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer">
      <img src="@/assets/images/misc/sendinvites.png" class="w-24 float-left mr-4 mb-2"/>
      <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
      <h5 class="font-semibold">Send invites now</h5>
      <p class="mt-2">Send email or text invites to customers directly.</p>
    </vx-card>
    <vx-card slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer">
      <img src="@/assets/images/misc/askonsocial.png" class="w-24 float-left mr-4 mb-3"/>
      <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
      <h5 class="font-semibold">Ask online now</h5>
      <p class="mt-2">The best way to get feedback is to ask! Ask your followers on Facebook, LinkedIn or X.</p>
    </vx-card>
    <vx-card slot="no-body" class="bg-transparent my-4 w-full block overflow-auto cursor-pointer">
      <img src="@/assets/images/misc/email.png" class="w-24 float-left mr-4"/>
      <img src="@/assets/images/misc/arrowright.png" class="hidden md:block w-24 float-right"/>
      <h5 class="font-semibold">Include in day-to-day emails</h5>
      <p class="mt-2">Get responses from customers from your email signature or daily emails.</p>
    </vx-card>
  </div>
  <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
    <vx-card slot="no-body" class="my-4 w-full block overflow-auto">
      <h5 class="uppercase mb-4">Your Survey Flow</h5>
      <p>Add your own questions by clicking "Add Question" below.</p>
      <div class="my-10 pt_rnd_cont">
        How likely are you to recommend _____ to others?
      </div>
    </vx-card>
  </div>
</div>

<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base flex">
  <vx-card slot="no-body">
    <div>
      <h5 class="uppercase mb-4">Set up Questions</h5>
      <p class="my-6 mb-2 font-medium">Set up questions for supportive customers, get summarized answers.</p>
      <img class="w-full mx-auto block my-4 py-2" src="@/assets/images/misc/completesurvey.png"/>
      <vs-button class="w-full" @click="$router.push('/dash/surveyquestions')">Set up Questions</vs-button>
    </div>
  </vx-card>
</div>

<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base flex">
  <vx-card slot="no-body" class="my-10 w-full">
      <img class="w-32" src="@/assets/images/misc/linkqrcode.png"/>
  </vx-card>
  <vx-card slot="no-body" class="my-10 w-full">
      <img src="@/assets/images/misc/sendinvites.png"/>
  </vx-card>
  <vx-card slot="no-body" class="my-10 w-full">
      <img src="@/assets/images/misc/embed.png"/>
  </vx-card>
  <vx-card slot="no-body" class="my-10 w-full">
      <img src="@/assets/images/misc/email.png"/>
  </vx-card>
  <vx-card slot="no-body" class="my-10 w-full">
      <img src="@/assets/images/misc/email.png"/>
  </vx-card>
  <vx-card slot="no-body" class="my-10 w-full">
      <img src="@/assets/images/misc/askonsocial.png"/>
  </vx-card>
</div>

Right under <vx-card>
<template slot="actions">
  <vs-checkbox class="hidden sm:flex">Done</vs-checkbox>
</template>

<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base flex">
  <div slot="no-body" class="text-center p-3">
    <div>
      <img class="w-3/12 mx-auto block mb-6" src="@/assets/images/misc/notknow.png"/>
      <h4 class="font-medium mb-2">Need guidance?</h4>
      <vs-button class="my-2 w-full" type="flat">Introduction ></vs-button>
      <vs-button class="my-2 w-full" type="flat">FAQ</vs-button>
      <vs-button class="my-2 w-full" type="flat">Contact Us ></vs-button>
    </div>
  </div>
</div>

<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base flex" v-if="$store.getters['dash/sAR'].noActive > 0">
  <vx-card title="Promoter link" class="text-center bg-transparent">
    <template slot="actions">
      <vx-tooltip text="When the time is right, send a happy customer straight to this list of all your specified review and share platforms. Click on it to test it out!" position="bottom">
        <feather-icon icon="HelpCircleIcon" svgClasses="stroke-current text-light w-6 h-6"/>
      </vx-tooltip>
    </template>
<div class="mt-2">
<img src="@/assets/images/misc/happy.png" class="w-10 block mx-auto"/>
  <vs-button class="px-0 mx-auto lg:text-2xl  my-3" type="flat" size="large" :href="$store.getters['dash/happyLinkTest']" target="_blank">{{ $store.getters['dash/happyLink'] }}</vs-button>
<p class="text-lg font-medium  mb-2" style="min-height: 3.6rem;">Send <span class="font-medium">happy customers</span> here to instantly review and share online.</p>
<div class="inline-block">
  <vs-button class="my-2" type="line" icon-pack="feather" icon="icon-download" @click="downloadHappyQR">Download QR Code</vs-button>
</div>
</div>
</vx-card>
</div>

<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base flex">
  <vx-card title="Complaints link" class="text-center bg-transparent">
    <template slot="actions">
      <vx-tooltip text="When the time is right, this link/QR code will take a customer straight to a complaint input form. Click on it to test it out!" position="bottom">
        <feather-icon icon="HelpCircleIcon" svgClasses="stroke-current text-light w-6 h-6"/>
      </vx-tooltip>
    </template>
    <div class="mt-2">
      <img src="@/assets/images/misc/unhappy.png" class="block w-10 mx-auto"/>
    <vs-button class="px-0 mx-auto lg:text-2xl my-3" type="flat" size="large" :href="$store.getters['dash/unhappyLinkTest']" target="_blank" >{{ $store.getters['dash/unhappyLink'] }}</vs-button>
    <p class="text-lg font-medium  mb-2" style="min-height: 3.6rem;">Send <span class="font-medium">unsatisfied customers</span> here for direct complaints.</p>
    <div class="inline-block">
      <vs-button class="my-2" type="line"  icon-pack="feather" icon="icon-download" @click="downloadUnhappyQR">Download QR Code</vs-button>
    </div>
    </div>
  </vx-card>
</div>

<!-- CARD 3: ORDER RECIEVED -->
<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base flex">
  <div slot="no-body" class="text-center p-3">
    <div>
      <h3 class="font-medium">Ask Online</h3>
      <p class="my-8">Share your feedback link with your followers!</p>
      <vs-button class="w-full my-3" color="#3B5998" icon-pack="feather" icon="icon-external-link" icon-after >Facebook</vs-button>
      <vs-button class="w-full my-3" color="#0072B1" icon-pack="feather" icon="icon-external-link" icon-after >LinkedIn</vs-button>
      <vs-button class="w-full my-3" color="#000000" icon-pack="feather" icon="icon-external-link" icon-after >X</vs-button>
    </div>
  </div>
</div>

*/



</script>

<style lang="scss" scoped>
/*! rtl:begin:ignore */

#confetti {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    opacity: 0;
    visibility: hidden;
    animation: hide 60s;
    &.confettiFull {
      position: fixed;
      z-index: 99999;
      animation: hide 120s;
    }
}

@keyframes hide {
	0% {
    opacity: 1;
    visibility: visible;
	}
  90% {
    opacity: 0.5;
    visibility: visible;
  }
	100% {
    opacity: 0;
    visibility: hidden;
	}
}

#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 110px;
    }
  }
}
/*! rtl:end:ignore */
.vue-star-rating-rating-text{
  font-weight: 600;
  color: #4c4c4c;
  font-size: 1.4rem;
}

.text-danger { 
 .vue-star-rating-rating-text {
    color: #EA5455;
  }           
}

.text-warning {
 .vue-star-rating-rating-text {
        color:#FF9F43;
    }  
  }

.text-success { 
  .vue-star-rating-rating-text {
      color: #28C76F;
  }
 }  




</style>
